export const ID53 = () => {
    return (
        <div>
            <div className="content" readonly="">
                <h1 className="servicePage_title">Кибернетика:Подсистема "Материально-технического обеспечения" для
                    "Бухгалтерия для Казахстана", ред. 3.0"</h1>
                <div>
                    <div>Разработчик: ТОО «Кибернетика.com»<br/></div>
                    <div>Категория: Дополнение к конфигурациям, разработанные без использования механизма расширений.
                    </div>
                    <div><br/></div>
                    <div>Отрасли: Добывающая промышленность; Нефтяная, газовая промышленность</div>
                    <div><br/></div>
                    <div>Описание: Продукт предназначен для автоматизации процесса формирования, подачи и согласования
                        заявок для формирования бюджета, Плана закупок, заявок на закуп ТРУ и обеспечить последующий
                        контроль расходования денег в рамках утвержденного бюджета на планируемый год (включая
                        «аварийные», сверхплановые заявки) с использованием единого классификатора ТРУ.
                    </div>
                    <div>Основные функциональные возможности:</div>
                    <div>•автоматизация процесса консолидации всех заявленных
                        позиций с целью проведения закупочных процедур, заключения договоров;
                    </div>
                    <div>•усилить контроль исполнения заключенных договоров в
                        единой учетной системе 1С;
                    </div>
                    <div>•упорядочить складской учет с целью недопущения
                        образования неликвидов на складах;
                    </div>
                    <div>•получать своевременную и достоверную информацию в
                        виде аналитических отчетов с целью принятия оперативных решений;
                    </div>
                    <div>•повысить эффективность по взаимодействию всех
                        участников бизнес-процессов по заявочной кампании и автоматизации контроля приемки ТРУ.
                    </div>
                    <div><br/></div>
                    <div>Продукт «Кибернетика: Подсистема «Материально-Техническое обеспечение» для «Бухгалтерии для
                        Казахстана», ред. 3.0.49.1» разработан для «Бухгалтерия для Казахстана» системы программ
                        "1С:Предприятие 8" с сохранением всех основных возможностей и механизмов данного
                        решения.&nbsp;</div>
                    <div><br/></div>
                    <div>Для работы продукта необходимо наличие установленной платформы «1С:Предприятие 8.3»&nbsp; (не
                        ниже версии 8.3.17).
                    </div>
                    <div><br/></div>
                    <div>Вариант работы: Файловый, клиент – серверный.</div>
                    <div>Режим запуска: Управляемое приложение.</div>
                    <div>Конфигурируемость:&nbsp;</div>
                    <div>Программный код продукта полностью открыт.</div>
                </div>
                <div><br/></div>
            </div>
        </div>
    )
}